<div class="hvac-chip">
    <label [attr.for]="text" class="hvac-label hvac-chip-text">{{ text }}</label>
    <button [disabled]="disabled" class="hvac-button" hvacButton="default"
            (click)="removeChip()">
            <span class="hvac-accessible-text">Remove {{text}}</span>
            <utc-svg class="hvac-brand-close-button" src="assets/icons/close.svg"></utc-svg>
    </button>
</div>
